<div *ngIf="shouldShowMessage">
    <div class="message-container" *ngIf="showPendingMessage()" [ngClass]="{ 'disabled-overlay': showLockedMessage() }">
        <div class="text-container">
            <mat-icon svgIcon="lock-profile" data-cy="vessel-folder-req-access-approver-notif-msg-icon" />

            <div class="title-version-container">
                <div class="message-title" data-cy="vessel-folder-req-access-approver-notif-msg-header">
                    {{ 'request.access.message.pending.title' | translate: { userName: accessRequest.userName } }}
                </div>

                <div class="right-aligned">
                    {{ 'request.access.message.pending.version' | translate: { version: vessel.projectVersion } }}
                </div>
            </div>

            <div>
                <div class="text-message" data-cy="vessel-folder-req-access-approver-notif-msg-body">
                    {{ 'request.access.message.pending.message' | translate: { userName: accessRequest.userName } }}
                </div>
            </div>
        </div>

        <div class="buttons-container">
            <div
                class="reject button"
                data-cy="vessel-folder-req-access-approver-notif-msg-reject-btn"
                (click)="rejectRequest()">
                {{ 'request.access.message.pending.button.reject' | translate }}
            </div>
            <div
                class="approve button"
                data-cy="vessel-folder-req-access-approver-notif-msg-accept-btn"
                (click)="acceptRequest()">
                {{ 'request.access.message.pending.button.accept' | translate }}
            </div>
        </div>
    </div>

    <div *ngIf="showAcceptedMessage()" class="message-container">
        <ng-container *ngIf="!isOwnerVessel() && showLockedMessage()">
            <div class="text-container">
                <mat-icon svgIcon="lock-clock" data-cy="vessel-folder-req-access-requester-accept-notif-msg-icon" />
                <div class="message-title" data-cy="vessel-folder-req-access-requester-accept-notif-msg-header">
                    {{ 'request.access.message.accepted-locked.title' | translate }}
                </div>
                <div class="text-message" data-cy="vessel-folder-req-access-requester-accept-notif-msg-body1">
                    {{ 'request.access.message.accepted-locked.message.1' | translate }}
                </div>
                <div class="text-message" data-cy="vessel-folder-req-access-requester-accept-notif-msg-body2">
                    {{ 'request.access.message.accepted-locked.message.2' | translate }}
                </div>
            </div>

            <div class="buttons-container">
                <div
                    class="start-editing disabled-button"
                    data-cy="vessel-folder-req-access-requester-accept-notif-msg-start-edit-btn">
                    {{ 'request.access.message.accepted-locked.button.start' | translate }}
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="!showLockedMessage()">
            <div class="text-container">
                <mat-icon svgIcon="lock-clock" data-cy="vessel-folder-req-access-requester-accept-notif-msg-icon" />
                <div class="message-title" data-cy="vessel-folder-req-access-requester-accept-notif-msg-header">
                    {{ 'request.access.message.accepted.title' | translate }}
                </div>
                <div class="text-message" data-cy="vessel-folder-req-access-requester-accept-notif-msg-body1">
                    {{ 'request.access.message.accepted.message.1' | translate }}
                </div>
                <div class="text-message" data-cy="vessel-folder-req-access-requester-accept-notif-msg-body2">
                    {{ 'request.access.message.accepted.message.2' | translate }}
                </div>
            </div>

            <div class="buttons-container">
                <div
                    class="start-editing button"
                    data-cy="vessel-folder-req-access-requester-accept-notif-msg-start-edit-btn"
                    (click)="startEditing()">
                    {{ 'request.access.message.accepted.button.start' | translate }}
                </div>
            </div>
        </ng-container>
    </div>

    <div *ngIf="showRejectedMessage()" class="message-container">
        <div class="text-container">
            <mat-icon svgIcon="approval" class="approval-icon" />
            <div class="message-title" data-cy="vessel-folder-req-access-requester-reject-notif-msg-header">
                {{ 'request.access.message.rejected.title' | translate }}
            </div>
        </div>
        <div class="buttons-container">
            <div class="button" (click)="closeRejectedMessage()">
                {{ 'request.access.message.removed.button' | translate }}
            </div>
        </div>
    </div>

    <div *ngIf="showRemovedMessage()" class="message-container">
        <div class="text-container">
            <mat-icon svgIcon="lock" class="approval-icon" />
            <div class="message-title">
                {{ 'request.access.message.removed.title' | translate }}
            </div>
            <div class="text-message">
                {{ 'request.access.message.removed.message' | translate }}
            </div>
        </div>
        <div class="buttons-container">
            <div class="button" (click)="closeRemovedMessage()">
                {{ 'request.access.message.removed.button' | translate }}
            </div>
        </div>
    </div>
</div>
